export default __webpack_public_path__ + "media/images/features/hida/access-train-305f377ff652df969341e28587ce90fc.png";